import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  MdDelete,
  MdEditOff,
  MdModeEdit,
  MdOutlineEditOff,
} from "react-icons/md";
import { FaSave } from "react-icons/fa";
import { useGlobalContext } from "../../../Context/GlobalContext";
const urlPrefix = process.env.REACT_APP_URL_PREFIX;

const insertUrl = `${urlPrefix}insert/insertData`;
const updateUrl = `${urlPrefix}updateAllMasterData`;
const deleteUrl = `${urlPrefix}delete/anytable`;

// columns to hide
const hiddenColumns = ["id", "current_time", "updated_at"];

export default function SimpleDynamicTable({ tableName = "t_notice_cls" }) {
  const { userData } = useGlobalContext();
  const [columns, setColumns] = useState([]);
  const [tempColumns, setTempColumns] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const [rows, setRows] = useState([]);
  const [originalRows, setOriginalRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadTable();
  }, [tableName]);

  // MYSQL TYPE -> HTML INPUT TYPE
  const getInputType = (mysqlType = "") => {
    const type = mysqlType.toLowerCase();

    if (
      type.includes("int") ||
      type.includes("decimal") ||
      type.includes("float") ||
      type.includes("double")
    ) {
      return "number";
    }

    if (type.includes("datetime") || type.includes("timestamp")) {
      return "datetime-local";
    }

    if (type === "date" || type.startsWith("date(")) {
      return "date";
    }

    if (type.includes("time")) {
      return "time";
    }

    if (type.includes("tinyint(1)") || type.includes("boolean")) {
      return "checkbox";
    }

    return "text";
  };

  // INSERT
  const insertRecord = async (tableName, data) => {
    const payload = {
      table_name: tableName,
      data,
    };

    // console.log("Insert Payload:", payload);

    const response = await axios.post(insertUrl, payload);

    return response.data;
  };

  // UPDATE
  const updateRecord = async (tableName, rows) => {
    console.log(rows);
    const payload = {
      table_name: tableName,
      rows,
    };

    // console.log("Update Payload:", payload);

    const response = await axios.put(updateUrl, payload);

    return response.data;
  };

  // DELETE
  const deleteRecord = async (tableName, id) => {
    const payload = {
      table_name: tableName,
      column_name: "id",
      value: id,
    };

    const response = await axios.delete(deleteUrl, {
      data: payload,
    });

    return response.data;
  };

  // LOAD TABLE
  const loadTable = async () => {
    try {
      setLoading(true);

      // schema
      const schemaRes = await axios.get(`${urlPrefix}describe/${tableName}`);

      const visibleColumns = schemaRes.data.columns
        .filter((c) => !hiddenColumns.includes(c.Field))
        .map((c) => ({
          name: c.Field,
          mysqlType: c.Type,
          inputType: getInputType(c.Type),
          nullable: c.Null === "YES",
          defaultValue: c.Default,
        }));
      setTempColumns(visibleColumns);
      setColumns(
        visibleColumns.filter(
          (f) => f.name === "ldgn_notice" || f.name === "showNotice",
        ),
      );

      // data
      const dataRes = await axios.get(
        `${urlPrefix}allMasterData?table_name=${tableName}`,
      );

      const data = (dataRes.data.data || []).map((r) => ({
        ...r,

        isNew: false,
      }));

      setRows(data);
      setOriginalRows(JSON.parse(JSON.stringify(data)));
    } catch (err) {
      console.error(err);
      setRows([]);
      setOriginalRows([]);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!disabled) {
      setColumns(
        tempColumns.filter(
          (f) => f.name === "ldgn_notice" || f.name === "showNotice",
        ),
      );
    } else {
      setColumns(tempColumns.filter((f) => f.name === "ldgn_notice"));
    }
  }, [disabled]);

  // CHANGE
  const handleChange = (rowId, field, value) => {
    setRows((prev) =>
      prev.map((row) => {
        // Existing row
        if (row.id && row.id === rowId) {
          return {
            ...row,
            [field]: value,
          };
        }

        // New row
        if (!row.id && row.tempId === rowId) {
          return {
            ...row,
            [field]: value,
          };
        }

        return row;
      }),
    );
  };

  // ADD ROW
  const addRow = () => {
    const obj = {
      tempId: Date.now(),
    };

    tempColumns.forEach((col) => {
      if (col.name === "showNotice") {
        obj[col.name] = "false";
      } else {
        obj[col.name] = col.inputType === "checkbox" ? false : "";
      }
    });

    obj.isNew = true;

    setRows((prev) => [...prev, obj]);
  };

  // SAVE SINGLE ROW
  const saveRow = async (row) => {
    try {
      setLoading(true);

      // INSERT
      if (row.isNew) {
        const { isNew, ...payload } = row;
        await insertRecord(tableName, [
          { ...payload, created_by: userData.id },
        ]);

        alert("Inserted Successfully");
        await loadTable();
        return;
      }

      // UPDATE
      const oldRow = originalRows.find((r) => r.id === row.id);

      if (!oldRow) return;

      const updates = {};
      console.log("Old:", oldRow.showNotice);
      console.log("New:", row.showNotice);

      Object.keys(row).forEach((key) => {
        if (["id", "isNew", "tempId"].includes(key)) return;

        const oldValue = String(oldRow[key] ?? "").trim();
        const newValue = String(row[key] ?? "").trim();

        if (oldValue !== newValue) {
          updates[key] = row[key];
        }
      });

      console.log(updates);
      if (Object.keys(updates).length) {
        await updateRecord(tableName, [
          {
            id: row.id,
            updates: { ...updates, updated_by: userData.id },
          },
        ]);

        alert("Updated Successfully");
        await loadTable();
      } else {
        alert("No Changes Found");
      }
    } catch (err) {
      console.error(err);
      alert("Save Failed");
    } finally {
      setLoading(false);
    }
  };

  // DELETE ROW
  const deleteRow = async (row) => {
    try {
      if (row.isNew) {
        setRows((prev) =>
          prev.filter((r) => (r.id || r.tempId) !== (row.id || row.tempId)),
        );
        return;
      }

      const confirm = window.confirm("Delete this record?");

      if (!confirm) return;

      setLoading(true);

      await deleteRecord(tableName, row.id);

      alert("Deleted Successfully");

      await loadTable();
    } catch (err) {
      console.error(err);
      alert("Delete Failed");
    } finally {
      setLoading(false);
    }
  };

  // INPUT RENDERER
  const renderInput = (row, column) => {
    const rowKey = row.id || row.tempId;

    if (column.name === "showNotice") {
      return (
        <input
          disabled={disabled}
          type="checkbox"
          checked={String(row[column.name]).toLowerCase() === "true"}
          onChange={(e) =>
            handleChange(
              rowKey,
              column.name,
              e.target.checked ? "true" : "false",
            )
          }
        />
      );
    }

    if (column.inputType === "checkbox") {
      return (
        <input
          disabled={disabled}
          type="checkbox"
          checked={!!row[column.name]}
          onChange={(e) => handleChange(rowKey, column.name, e.target.checked)}
        />
      );
    }

    if (column.inputType === "text") {
      return (
        <textarea
          disabled={disabled}
          className="form-control"
          rows={2}
          style={{
            minWidth: "200px",
            resize: "vertical",
          }}
          value={row[column.name] ?? ""}
          onChange={(e) => handleChange(rowKey, column.name, e.target.value)}
        />
      );
    }

    return (
      <input
        disabled={disabled}
        className="form-control"
        type={column.inputType}
        value={row[column.name] ?? ""}
        onChange={(e) => handleChange(rowKey, column.name, e.target.value)}
      />
    );
  };
  return (
    <div style={{ padding: 20 }}>
      <div className="row">
        <h5 className="bg-dark text-white m-1 p-1">Loading Notice</h5>
      </div>
      <div
        className="table-responsive"
        style={{ maxHeight: "400px", overflow: "auto" }}
      >
        <table className="table table-striped table-hover">
          <thead>
            <tr className="sticky-top">
              <th>Sr</th>
              {columns.map((column) => (
                <th
                  style={{
                    width: column.name === "showNotice" ? "30px" : "auto",
                  }}
                  key={column.name}
                >
                  {column.name === "showNotice" ? "Show" : column.name}
                </th>
              ))}

              <th style={{ width: "50px" }}>
                {" "}
                <div className="d-flex">
                  <button
                    className={`btn btn-sm btn-outline-${disabled ? "success" : "danger"} me-2`}
                    onClick={() => {
                      setDisabled(!disabled);
                    }}
                  >
                    {disabled ? <MdEditOff /> : <MdModeEdit />}
                  </button>{" "}
                  <button
                    className="btn btn-sm btn-outline-primary"
                    onClick={addRow}
                    disabled={loading}
                  >
                    +
                  </button>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {!rows.filter((f) => (disabled ? f.showNotice === "true" : true))
              .length ? (
              <tr>
                <td colSpan={columns.length + 1}>No Data Found</td>
              </tr>
            ) : (
              rows
                .filter((f) => (disabled ? f.showNotice === "true" : true))
                .sort((a, b) => {
                  const aValue = a.showNotice === "true" ? 1 : 0;
                  const bValue = b.showNotice === "true" ? 1 : 0;
                  return bValue - aValue;
                })
                .map((row, rowIndex) => (
                  <tr key={row.id || row.tempId}>
                    <td style={{ width: "20px" }}>{rowIndex + 1}</td>

                    {columns.map((column) => (
                      <td key={column.name}>{renderInput(row, column)}</td>
                    ))}

                    <td>
                      <div className="d-flex gap-2">
                        <button
                          className={`btn btn-sm ${
                            row.isNew ? "btn-primary" : "btn-success"
                          }`}
                          disabled={loading || disabled}
                          onClick={() => saveRow(row)}
                        >
                          {row.isNew ? "Insert" : <FaSave />}
                        </button>

                        <button
                          className="btn btn-sm btn-danger"
                          disabled={loading || disabled}
                          onClick={() => deleteRow(row)}
                        >
                          <MdDelete />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
